(function($) {
	'use strict';

	var init = function() {
		$('#logoutBtn').on('click', triggerLogout);
	};

	var triggerLogout = function(event) {
		event.preventDefault();
		document.getElementById('logout-form').submit();
	};

	$(document).ready(function() {
		init();
	});

})(jQuery);